export default "__VITE_ASSET__pfjGaHH7__"